define([
    "./panelModule",
    "./panelDirective"
], function () {
});